export const sectionsProperty = ['sections', 'sec'];
export const fontSubstitutionTableProperty = ['fontSubstitutionTable', 'fst'];
export const characterFormatProperty = ['characterFormat', 'cf'];
export const paragraphFormatProperty = ['paragraphFormat', 'pf'];
export const listsProperty = ['lists', 'li'];
export const abstractListsProperty = ['abstractLists', 'al'];
export const backgroundProperty = ['background', 'bg'];
export const stylesProperty = ['styles', 'sty'];
export const commentsProperty = ['comments', 'cm'];
export const revisionsProperty = ['revisions', 'r'];
export const customXmlProperty = ['customXml', 'cx'];
export const defaultTabWidthProperty = ['defaultTabWidth', 'dtw'];
export const formattingProperty = ['formatting', 'fmt'];
export const trackChangesProperty = ['trackChanges', 'tc'];
export const protectionTypeProperty = ['protectionType', 'pt'];
export const enforcementProperty = ['enforcement', 'enf'];
export const hashValueProperty = ['hashValue', 'hv'];
export const saltValueProperty = ['saltValue', 'sv'];
export const cryptProviderTypeProperty = ['cryptProviderType', 'cpt'];
export const cryptAlgorithmClassProperty = ['cryptAlgorithmClass', 'cac'];
export const cryptAlgorithmTypeProperty = ['cryptAlgorithmType', 'cat'];
export const cryptAlgorithmSidProperty = ['cryptAlgorithmSid', 'cas'];
export const cryptSpinCountProperty = ['cryptSpinCount', 'csc'];
export const doNotUseHTMLParagraphAutoSpacingProperty = ['dontUseHTMLParagraphAutoSpacing', 'dhtml'];
export const alignTablesRowByRowProperty = ['alignTablesRowByRow', 'atrr'];
export const formFieldShadingProperty = ['formFieldShading', 'ffs'];
export const lastParagraphMarkCopiedProperty = ['lastParagraphMarkCopied', 'lpmc'];
export const footnotesProperty = ['footnotes', 'fn'];
export const endnotesProperty = ['endnotes', 'en'];
export const compatibilityModeProperty = ['compatibilityMode', 'comp'];
export const themeFontLanguagesProperty = ['themeFontLanguages', 'tfl'];
export const themesProperty = ['themes', 'thm'];
export const nameProperty = ['name', 'n'];
export const basedOnProperty = ['basedOn', 'b'];
export const nextProperty = ['next', 'nx'];
export const linkProperty = ['link', 'l'];
export const localeIdProperty = ['localeId', 'id'];
export const localeIdFarEastProperty = ['localeIdFarEast', 'idfe'];
export const localeIdBidiProperty = ['localeIdBidi', 'idbi'];
export const boldProperty = ['bold', 'b'];
export const italicProperty = ['italic', 'i'];
export const ligatureProperty = ['ligature', 'lig'];
export const underlineProperty = ['underline', 'u'];
export const underlineColorProperty = ['underlineColor', 'uc'];
export const fontHintTypeProperty = ['fontHintType', 'fht'];
export const baselineAlignmentProperty = ['baselineAlignment', 'ba'];
export const strikethroughProperty = ['strikethrough', 'st'];
export const highlightColorProperty = ['highlightColor', 'hc'];
export const fontSizeProperty = ['fontSize', 'fsz'];
export const fontColorProperty = ['fontColor', 'fc'];
export const fontFamilyProperty = ['fontFamily', 'ff'];
export const styleNameProperty = ['styleName', 'stn'];
export const bidiProperty = ['bidi', 'bi'];
export const bdoProperty = ['bdo', 'bdo'];
export const breakClearTypeProperty = ['breakClearType', 'bct'];
export const fontSizeBidiProperty = ['fontSizeBidi', 'fszbi'];
export const fontFamilyBidiProperty = ['fontFamilyBidi', 'ffbi'];
export const boldBidiProperty = ['boldBidi', 'bbi'];
export const italicBidiProperty = ['italicBidi', 'ibi'];
export const allCapsProperty = ['allCaps', 'ac'];
export const complexScriptProperty = ['complexScript', 'cs'];
export const fontFamilyAsciiProperty = ['fontFamilyAscii', 'ffa'];
export const fontFamilyFarEastProperty = ['fontFamilyFarEast', 'fffe'];
export const fontFamilyNonFarEastProperty = ['fontFamilyNonFarEast', 'ffnfe'];
export const revisionIdsProperty = ['revisionIds', 'rids'];
export const listIdProperty = ['listId', 'lid'];
export const characterSpacingProperty = ['characterSpacing', 'csp'];
export const scalingProperty = ['scaling', 'sc'];
export const listLevelNumberProperty = ['listLevelNumber', 'lilno'];
export const leftIndentProperty = ['leftIndent', 'lin'];
export const rightIndentProperty = ['rightIndent', 'rin'];
export const firstLineIndentProperty = ['firstLineIndent', 'fin'];
export const textAlignmentProperty = ['textAlignment', 'ta'];
export const afterSpacingProperty = ['afterSpacing', 'as'];
export const beforeSpacingProperty = ['beforeSpacing', 'bs'];
export const spaceAfterAutoProperty = ['spaceAfterAuto', 'saa'];
export const spaceBeforeAutoProperty = ['spaceBeforeAuto', 'sba'];
export const lineSpacingProperty = ['lineSpacing', 'ls'];
export const lineSpacingTypeProperty = ['lineSpacingType', 'lst'];
export const listFormatProperty = ['listFormat', 'lif'];
export const keepWithNextProperty = ['keepWithNext', 'kwn'];
export const widowControlProperty = ['widowControl', 'wc'];
export const keepLinesTogetherProperty = ['keepLinesTogether', 'klt'];
export const outlineLevelProperty = ['outlineLevel', 'ol'];
export const contextualSpacingProperty = ['contextualSpacing', 'cs'];
export const bordersProperty = ['borders', 'bdrs'];
export const tabsProperty = ['tabs', 'tb'];
export const headerDistanceProperty = ['headerDistance', 'hd'];
export const footerDistanceProperty = ['footerDistance', 'fd'];
export const differentFirstPageProperty = ['differentFirstPage', 'dfp'];
export const differentOddAndEvenPagesProperty = ['differentOddAndEvenPages', 'doep'];
export const pageWidthProperty = ['pageWidth', 'pw'];
export const pageHeightProperty = ['pageHeight', 'ph'];
export const leftMarginProperty = ['leftMargin', 'lm'];
export const rightMarginProperty = ['rightMargin', 'rm'];
export const topMarginProperty = ['topMargin', 'tm'];
export const bottomMarginProperty = ['bottomMargin', 'bm'];
export const restartPageNumberingProperty = ['restartPageNumbering', 'rpn'];
export const pageStartingNumberProperty = ['pageStartingNumber', 'psn'];
export const endnoteNumberFormatProperty = ['endnoteNumberFormat', 'enf'];
export const footNoteNumberFormatProperty = ['footNoteNumberFormat', 'fnf'];
export const restartIndexForFootnotesProperty = ['restartIndexForFootnotes', 'rif'];
export const restartIndexForEndnotesProperty = ['restartIndexForEndnotes', 'rie'];
export const initialFootNoteNumberProperty = ['initialFootNoteNumber', 'ifn'];
export const initialEndNoteNumberProperty = ['initialEndNoteNumber', 'ien'];
export const pageNumberStyleProperty = ['pageNumberStyle', 'pgns'];
export const columnsProperty = ['columns', 'cols'];
export const numberOfColumnsProperty = ['numberOfColumns', 'ncols'];
export const equalWidthProperty = ['equalWidth', 'eqw'];
export const lineBetweenColumnsProperty = ['lineBetweenColumns', 'lbtc'];
export const breakCodeProperty = ['breakCode', 'bc'];
export const cellWidthProperty = ['cellWidth', 'cw'];
export const columnSpanProperty = ['columnSpan', 'colsp'];
export const rowSpanProperty = ['rowSpan', 'rwsp'];
export const verticalAlignmentProperty = ['verticalAlignment', 'va'];
export const allowBreakAcrossPagesProperty = ['allowBreakAcrossPages', 'abrk'];
export const isHeaderProperty = ['isHeader', 'hdr'];
export const heightTypeProperty = ['heightType', 'ht'];
export const beforeWidthProperty = ['beforeWidth', 'bw'];
export const afterWidthProperty = ['afterWidth', 'aw'];
export const gridBeforeProperty = ['gridBefore', 'gb'];
export const gridBeforeWidthProperty = ['gridBeforeWidth', 'gbw'];
export const gridBeforeWidthTypeProperty = ['gridBeforeWidthType', 'gbwt'];
export const gridAfterProperty = ['gridAfter', 'ga'];
export const gridAfterWidthProperty = ['gridAfterWidth', 'gaw'];
export const gridAfterWidthTypeProperty = ['gridAfterWidthType', 'gawt'];
export const allowAutoFitProperty = ['allowAutoFit', 'auft'];
export const cellSpacingProperty = ['cellSpacing', 'csp'];
export const shadingProperty = ['shading', 'sd'];
export const tableAlignmentProperty = ['tableAlignment', 'ta'];
export const preferredWidthProperty = ['preferredWidth', 'pw'];
export const preferredWidthTypeProperty = ['preferredWidthType', 'pwt'];
export const horizontalPositionAbsProperty = ['horizontalPositionAbs', 'hpa'];
export const textureProperty = ['texture', 't'];
export const backgroundColorProperty = ['backgroundColor', 'bgc'];
export const foregroundColorProperty = ['foregroundColor', 'fgc'];
export const shadowProperty = ['shadow', 'sh'];
export const hasNoneStyleProperty = ['hasNoneStyle', 'hns'];
export const verticalProperty = ['vertical', 'v'];
export const horizontalProperty = ['horizontal', 'h'];
export const diagonalUpProperty = ['diagonalUp', 'du'];
export const diagonalDownProperty = ['diagonalDown', 'dd'];
export const lineStyleProperty = ['lineStyle', 'ls'];
export const lineWidthProperty = ['lineWidth', 'lw'];
export const layoutProperty = ['layout', 'l'];
export const dataFormatProperty = ['dataFormat', 'df'];
export const yValueProperty = ['yValue', 'y'];
export const chartDataProperty = ['chartData', 'chd'];
export const categoryXNameProperty = ['categoryXName', 'cx'];
export const lineProperty = ['line', 'l'];
export const foreColorProperty = ['foreColor', 'fc'];
export const patternProperty = ['pattern', 'pt'];
export const layoutXProperty = ['layoutX', 'x'];
export const layoutYProperty = ['layoutY', 'y'];
export const directionProperty = ['direction', 'dir'];
export const endStyleProperty = ['endStyle', 'est'];
export const numberValueProperty = ['numberValue', 'no'];
export const markerStyleProperty = ['markerStyle', 'mst'];
export const markerColorProperty = ['markerColor', 'mc'];
export const markerSizeProperty = ['markerSize', 'msz'];
export const forwardProperty = ['forward', 'fw'];
export const backwardProperty = ['backward', 'bw'];
export const interceptProperty = ['intercept', 'itr'];
export const isDisplayRSquaredProperty = ['isDisplayRSquared', 'idrs'];
export const isDisplayEquationProperty = ['isDisplayEquation', 'ideq'];
export const seriesNameProperty = ['seriesName', 'sn'];
export const dataLabelProperty = ['dataLabel', 'sl'];
export const errorBarProperty = ['errorBar', 'eb'];
export const seriesFormatProperty = ['seriesFormat', 'sf'];
export const trendLinesProperty = ['trendLines', 'tl'];
export const dataPointsProperty = ['dataPoints', 'dp'];
export const firstSliceAngleProperty = ['firstSliceAngle', 'fsa'];
export const holeSizeProperty = ['holeSize', 'hsz'];
export const isLegendKeyProperty = ['isLegendKey', 'lk'];
export const isBubbleSizeProperty = ['isBubbleSize', 'bsz'];
export const isCategoryNameProperty = ['isCategoryName', 'icn'];
export const isSeriesNameProperty = ['isSeriesName', 'isn'];
export const isValueProperty = ['isValue', 'iv'];
export const isPercentageProperty = ['isPercentage', 'ip'];
export const isLeaderLinesProperty = ['isLeaderLines', 'il'];
export const showSeriesKeysProperty = ['showSeriesKeys', 'sk'];
export const hasHorizontalBorderProperty = ['hasHorzBorder', 'hhbdr'];
export const hasVerticalBorderProperty = ['hasVertBorder', 'hvbdr'];
export const hasBordersProperty = ['hasBorders', 'hbdr'];
export const categoryTypeProperty = ['categoryType', 'ct'];
export const chartCategoryProperty = ['chartCategory', 'c'];
export const chartSeriesProperty = ['chartSeries', 'cs'];
export const chartAreaProperty = ['chartArea', 'ca'];
export const chartTitleAreaProperty = ['chartTitleArea', 'cta'];
export const plotAreaProperty = ['plotArea', 'pa'];
export const chartLegendProperty = ['chartLegend', 'cl'];
export const chartPrimaryCategoryAxisProperty = ['chartPrimaryCategoryAxis', 'cpca'];
export const chartPrimaryValueAxisProperty = ['chartPrimaryValueAxis', 'cpva'];
export const chartTitleProperty = ['chartTitle', 'ctt'];
export const chartTypeProperty = ['chartType', 'ct'];
export const gapWidthProperty = ['gapWidth', 'gw'];
export const overlapProperty = ['overlap', 'o'];
export const chartDataTableProperty = ['chartDataTable', 'cdt'];
export const textProperty = ['text', 'tlp'];
export const shapeIdProperty = ['shapeId', 'sid'];
export const alternativeTextProperty = ['alternativeText', 'at'];
export const visibleProperty = ['visible', 'v'];
export const belowTextProperty = ['belowText', 'b'];
export const horizontalRuleProperty = ['horizontalRule', 'ihr'];
export const widthProperty = ['width', 'w'];
export const heightProperty = ['height', 'h'];
export const widthScaleProperty = ['widthScale', 'ws'];
export const heightScaleProperty = ['heightScale', 'hs'];
export const lineFormatProperty = ['lineFormat', 'lf'];
export const fillFormatProperty = ['fillFormat', 'ff'];
export const textWrappingStyleProperty = ['textWrappingStyle', 'tws'];
export const textWrappingTypeProperty = ['textWrappingType', 'twt'];
export const verticalRelativePercentProperty = ['verticalRelativePercent', 'vrp'];
export const horizontalRelativePercentProperty = ['horizontalRelativePercent', 'hrp'];
export const heightRelativePercentProperty = ['heightRelativePercent', 'hrp'];
export const widthRelativePercentProperty = ['widthRelativePercent', 'wrp'];
export const zOrderPositionProperty = ['zOrderPosition', 'z'];
export const layoutInCellProperty = ['layoutInCell', 'lc'];
export const lockAnchorProperty = ['lockAnchor', 'la'];
export const autoShapeTypeProperty = ['autoShapeType', 'ast'];
export const textFrameProperty = ['textFrame', 'tf'];
export const colorProperty = ['color', 'c'];
export const fillProperty = ['fill', 'f'];
export const textVerticalAlignmentProperty = ['textVerticalAlignment', 'tva'];
export const imageStringProperty = ['imageString', 'img'];
export const metaFileImageStringProperty = ['metaFileImageString', 'mtimg'];
export const lengthProperty = ['length', 'l'];
export const isInlineImageProperty = ['isInlineImage', 'inimg'];
export const isMetaFileProperty = ['isMetaFile', 'imf'];
export const hasImageReferenceProperty = ['hasImageReference', 'hir'];
export const topProperty = ['top', 'tp'];
export const bottomProperty = ['bottom', 'bt'];
export const rightProperty = ['right', 'rg'];
export const leftProperty = ['left', 'lt'];
export const getImageHeightProperty = ['getimageheight', 'gih'];
export const getImageWidthProperty = ['getimagewidth', 'giw'];
export const hasFieldEndProperty = ['hasFieldEnd', 'hfe'];
export const formFieldDataProperty = ['formFieldData', 'ffd'];
export const fieldTypeProperty = ['fieldType', 'ft'];
export const isCreatedUsingHtmlSpanTagProperty = ['isCreatedUsingHtmlSpanTag', 'ishst'];
export const enabledProperty = ['enabled', 'e'];
export const helpTextProperty = ['helpText', 'h'];
export const statusTextProperty = ['statusText', 'st'];
export const textInputProperty = ['textInput', 'ti'];
export const checkBoxProperty = ['checkBox', 'c'];
export const dropDownListProperty = ['dropDownList', 'ddl'];
export const maxLengthProperty = ['maxLength', 'ml'];
export const defaultValueProperty = ['defaultValue', 'dv'];
export const formatProperty = ['format', 'f'];
export const sizeTypeProperty = ['sizeType', 'szt'];
export const sizeProperty = ['size', 'sz'];
export const checkedProperty = ['checked', 'chk'];
export const dropDownItemsProperty = ['dropDownItems', 'ddi'];
export const selectedIndexProperty = ['selectedIndex', 'si'];
export const commentIdProperty = ['commentId', 'cid'];
export const commentCharacterTypeProperty = ['commentCharacterType', 'cct'];
export const authorProperty = ['author', 'a'];
export const initialProperty = ['initial', 'i'];
export const dateProperty = ['date', 'dt'];
export const doneProperty = ['done', 'dn'];
export const replyCommentsProperty = ['replyComments', 'rc'];
export const revisionTypeProperty = ['revisionType', 'rt'];
export const revisionIdProperty = ['revisionId', 'rid'];
export const customDataProperty = ['customData', 'cd'];
export const itemIDProperty = ['itemID', 'iid'];
export const xmlProperty = ['xml', 'x'];
export const footnoteTypeProperty = ['footnoteType', 'fnt'];
export const symbolCodeProperty = ['symbolCode', 'sc'];
export const symbolFontNameProperty = ['symbolFontName', 'sfn'];
export const customMarkerProperty = ['customMarker', 'cm'];
export const inlinesProperty = ['inlines', 'i'];
export const contentControlPropertiesProperty = ['contentControlProperties', 'ccp'];
export const lockContentControlProperty = ['lockContentControl', 'lcc'];
export const lockContentsProperty = ['lockContents', 'lc'];
export const tagProperty = ['tag', 'tg'];
export const titleProperty = ['title', 'tt'];
export const hasPlaceHolderTextProperty = ['hasPlaceHolderText', 'hpt'];
export const multiLineProperty = ['multiline', 'mul'];
export const isTemporaryProperty = ['isTemporary', 'it'];
export const dateCalendarTypeProperty = ['dateCalendarType', 'dtct'];
export const dateStorageFormatProperty = ['dateStorageFormat', 'dtsf'];
export const dateDisplayLocaleProperty = ['dateDisplayLocale', 'dtdl'];
export const dateDisplayFormatProperty = ['dateDisplayFormat', 'dtdf'];
export const isCheckedProperty = ['isChecked', 'ichk'];
export const uncheckedStateProperty = ['uncheckedState', 'uchk'];
export const checkedStateProperty = ['checkedState', 'chks'];
export const contentControlListItemsProperty = ['contentControlListItems', 'ccli'];
export const xmlMappingProperty = ['xmlMapping', 'x'];
export const fontProperty = ['font', 'f'];
export const valueProperty = ['value', 'v'];
export const displayTextProperty = ['displayText', 'dt'];
export const isMappedProperty = ['isMapped', 'imap'];
export const isWordMlProperty = ['isWordMl', 'iwml'];
export const prefixMappingProperty = ['prefixMapping', 'pmap'];
export const xPathProperty = ['xPath', 'xp'];
export const storeItemIdProperty = ['storeItemId', 'siid'];
export const customXmlPartProperty = ['customXmlPart', 'cxp'];
export const idProperty = ['id', 'i'];
export const cellFormatProperty = ['cellFormat', 'tcpr'];
export const rowFormatProperty = ['rowFormat', 'trpr'];
export const cellsProperty = ['cells', 'c'];
export const rowsProperty = ['rows', 'r'];
export const descriptionProperty = ['description', 'desc'];
export const wrapTextAroundProperty = ['wrapTextAround', 'wta'];
export const isLegalStyleNumberingProperty = ['isLegalStyleNumbering', 'isLgl'];
export const positioningProperty = ['positioning', 'p'];
export const tableFormatProperty = ['tableFormat', 'tblpr'];
export const allowOverlapProperty = ['allowOverlap', 'ao'];
export const distanceTopProperty = ['distanceTop', 'dt'];
export const distanceRightProperty = ['distanceRight', 'dr'];
export const distanceLeftProperty = ['distanceLeft', 'dl'];
export const distanceBottomProperty = ['distanceBottom', 'db'];
export const verticalOriginProperty = ['verticalOrigin', 'vo'];
export const verticalPositionProperty = ['verticalPosition', 'vp'];
export const horizontalOriginProperty = ['horizontalOrigin', 'ho'];
export const horizontalAlignmentProperty = ['horizontalAlignment', 'ha'];
export const horizontalPositionProperty = ['horizontalPosition', 'hp'];
export const blocksProperty = ['blocks', 'b'];
export const headerProperty = ['header', 'h'];
export const footerProperty = ['footer', 'f'];
export const evenHeaderProperty = ['evenHeader', 'eh'];
export const evenFooterProperty = ['evenFooter', 'ef'];
export const firstPageHeaderProperty = ['firstPageHeader', 'fph'];
export const firstPageFooterProperty = ['firstPageFooter', 'fpf'];
export const headersFootersProperty = ['headersFooters', 'hf'];
export const sectionFormatProperty = ['sectionFormat', 'secpr'];
export const listLevelPatternProperty = ['listLevelPattern', 'lilp'];
export const followCharacterProperty = ['followCharacter', 'fchar'];
export const startAtProperty = ['startAt', 'sa'];
export const restartLevelProperty = ['restartLevel', 'rl'];
export const levelNumberProperty = ['levelNumber', 'lvlno'];
export const numberFormatProperty = ['numberFormat', 'nf'];
export const paraStyleNameProperty = ['paraStyleName', 'psty'];
export const abstractListIdProperty = ['abstractListId', 'alid'];
export const nsidProperty = 'nsid';
export const levelsProperty = ['levels', 'lvl'];
export const overrideListLevelProperty = ['overrideListLevel', 'o'];
export const levelOverridesProperty = ['levelOverrides', 'lo'];
export const separatorProperty = ['separator', 's'];
export const continuationSeparatorProperty = ['continuationSeparator', 'cs'];
export const continuationNoticeProperty = ['continuationNotice', 'cn'];
export const bookmarkTypeProperty = ['bookmarkType', 'bkt'];
export const propertiesProperty = ['properties', 'p'];
export const tabJustificationProperty = ['tabJustification', 'tj'];
export const positionProperty = ['position', 'p'];
export const deletePositionProperty = ['deletePosition', 'dp'];
export const leaderProperty = ['leader', 'l'];
export const tabLeaderProperty = ['tabLeader', 'tl'];
export const editRangeIdProperty = ['editRangeId', 'erid'];
export const columnFirstProperty = ['columnFirst', 'cft'];
export const columnLastProperty = ['columnLast', 'clt'];
export const userProperty = ['user', 'u'];
export const groupProperty = ['group', 'g'];
export const editableRangeStartProperty = ['editableRangeStart', 'ers'];
export const spaceProperty = ['space', 'sp'];
export const fontSchemeProperty = ['fontScheme', 'fsc'];
export const fontSchemeNameProperty = ['fontSchemeName', 'fscn'];
export const majorFontSchemeProperty = ['majorFontScheme', 'majfs'];
export const minorFontSchemeProperty = ['minorFontScheme', 'minfs'];
export const fontSchemeListProperty = ['fontSchemeList', 'fsl'];
export const fontTypefaceProperty = ['fontTypeface', 'ft'];
export const typefaceProperty = ['typeface', 't'];
export const panoseProperty = ['panose', 'p'];
export const typeProperty = ['type', 't'];
export const majorUnitProperty = ['majorUnit', 'maju'];
export const isAutoMajorProperty = ['isAutoMajor', 'iam'];
export const maximumValueProperty = ['maximumValue', 'maxv'];
export const minimumValueProperty = ['minimumValue', 'minv'];
export const hasMajorGridLinesProperty = ['hasMajorGridLines', 'hmajgl'];
export const hasMinorGridLinesProperty = ['hasMinorGridLines', 'hmingl'];
export const majorTickMarkProperty = ['majorTickMark', 'majtm'];
export const minorTickMarkProperty = ['minorTickMark', 'mintm'];
export const tickLabelPositionProperty = ['tickLabelPosition', 'tlp'];
export const rgbProperty = ['rgb', 'rgb'];
export const appearanceProperty = ['appearance', 'a'];
export const lineFormatTypeProperty = ['lineFormatType', 'lft'];
export const allowSpaceOfSameStyleInTableProperty = ['allowSpaceOfSameStyleInTable', 'stytbl'];
export const weightProperty = ['weight', 'w'];
export const inlineFormatProperty = ['inlineFormat', 'inf'];
export const fontNameProperty = ['fontName', 'fn'];
export const isCompressedProperty = ['isCompressed', 'comp'];
export const columnIndexProperty = ['columnIndex', 'ci'];
export const imagesProperty = ['images', 'imgs'];
export const isAfterParagraphMarkProperty = ['isAfterParagraphMark', 'apm'];
export const isAfterCellMarkProperty = ['isAfterCellMark', 'acm'];
export const isAfterRowMarkProperty = ['isAfterRowMark', 'arm'];
export const gridProperty = ['grid', 'grd'];
export const columnCountProperty = ['columnCount', 'colc'];
export const isAfterTableMarkProperty = ['isAfterTableMark', 'atm'];
export const incrementalOps = ['iOps'];
export const hiddenProperty = ['hidden', 'hdn'];
export const editingPointsProperty = ['editingpoints', 'ep'];
export const childShapeProperty = ['childShapes', 'csh'];
export const offsetXValue = ['offsetXValue', 'oxv'];
export const offsetYValue = ['offsetYValue', 'oyv'];
export const extentXValue = ['extentXValue', 'exv'];
export const extentYValue = ['extentYValue', 'eyv'];
export const allowHyphensInBookmarkNamesProperty = ['allowHyphensInBookmarkNames', 'ahb'];
